export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40beb7c5b913b81a067229bf6406387259d317d1a8&name=revalidateCommunity!'